const doc = [({"csv_header":["チーム名", "ユーザー名", "使用アプリケーション名", "対象年月日", "使用時間"]})];
module.exports = doc.length <= 1 ? doc[0] : doc;